import { put , call } from 'redux-saga/effects';
import langs from '../lang';
// import * as rs from 'react-redux-i18n/build/actions';
// {LOAD_TRANSLATIONS, SET_LOCALE}
export default function* i18nFlowSaga() {
  yield put({ type: '@@i18n/LOAD_TRANSLATIONS', translations: langs });
  yield put({ type: '@@i18n/SET_LOCALE', locale: 'ua' });
}
